import React from 'react';

import Modal from 'components/partials/modal/modal';
import Button from 'components/partials/button/button';

interface ArchiveModelModalProps {
  loading?: boolean;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
}

const ArchiveModelModal = ({
  loading = false,
  onConfirm,
  onClose,
}: ArchiveModelModalProps): React.JSX.Element => (
  <Modal
    headerText="Archive model"
    headerClassName="!text-2xl font-bold"
    onCloseCallback={onClose}
    skipUnmountOnClose
    showCloseButton
    primaryAction={{ onClick: onConfirm, loading }}
    modalClassName="!w-[640px] px-5 pt-4 pb-5"
    data-testid="archive-model-modal"
    footer={
      <div className="flex justify-start items-center gap-4">
        <Button
          type="button"
          variant="brand-filled"
          size="md"
          onClick={onConfirm}
          loading={loading}
          data-testid="confirm-archive-model-button"
        >
          Archive
        </Button>
        <Button
          type="button"
          variant="brand-outlined"
          size="md"
          onClick={onClose}
          data-testid="cancel-archive-model-button"
        >
          Cancel
        </Button>
      </div>
    }
  >
    <p className="mt-2 text-base text-gray-600">
      This model will be moved from all models list to the archived models. Are
      you sure?
    </p>
  </Modal>
);

export default ArchiveModelModal;
